import {HttpError} from '@wix/http-client'
import {AnyAction} from 'redux'
import {RegistrationErrorKey} from '../../../../commons/enums'
import {PLACE_ORDER_OLD, UPDATE_ORDER_OLD, getOrder, placeOrder, updateOrder} from '../actions/placed-order'
import {RESERVE_TICKETS_OLD, makeReservation} from '../actions/reservation'
import {
  RESET_RSVP_ERROR_OLD,
  SEND_RSVP_OLD,
  UPDATE_RSVP_OLD,
  resetRsvpError,
  sendRsvp,
  updateRsvp,
} from '../actions/rsvp'
import {FormSubmitErrors} from '../types/state'

const getDefaultState = (): FormSubmitErrors => ({
  error: {},
  errorTime: null,
  canRetry: false,
})

export const formSubmitErrors = (state = getDefaultState(), action: AnyAction) => {
  switch (action.type) {
    case SEND_RSVP_OLD.FAILURE:
    case PLACE_ORDER_OLD.FAILURE:
    case UPDATE_ORDER_OLD.FAILURE:
    case UPDATE_RSVP_OLD.FAILURE: {
      const error: HttpError = action.error
      return {
        ...state,
        error: error?.response?.data?.metadata ?? {error_key: RegistrationErrorKey.UNKNOWN_REGISTRATION_ERROR},
        canRetry: canRetryError(error),
        errorTime: new Date(),
      }
    }
    case placeOrder.rejected.toString():
    case updateOrder.rejected.toString():
    case sendRsvp.rejected.toString():
    case updateRsvp.rejected.toString(): {
      const error: HttpError = action.payload
      return {
        ...state,
        error: error?.response?.data?.metadata ?? {error_key: RegistrationErrorKey.UNKNOWN_REGISTRATION_ERROR},
        canRetry: canRetryError(error),
        errorTime: new Date(),
      }
    }
    case RESET_RSVP_ERROR_OLD:
    case resetRsvpError.toString():
    case PLACE_ORDER_OLD.SUCCESS:
    case placeOrder.fulfilled.toString():
    case UPDATE_ORDER_OLD.SUCCESS:
    case updateOrder.fulfilled.toString():
    case getOrder.fulfilled.toString():
    case RESERVE_TICKETS_OLD.REQUEST:
    case makeReservation.pending.toString():
    case UPDATE_RSVP_OLD.SUCCESS:
    case updateRsvp.fulfilled.toString():
      return {...state, error: {}, errorTime: null, canRetry: false}
    default:
      return state
  }
}

const canRetryError = (error: HttpError) => {
  return error?.response?.status > 500 || error?.response?.status === 429
}
